function cov_10ftcu4pd6() {
  var path = "/app/src/checkout-frame/utils/find-experiment.ts";
  var hash = "6ee4f2d56b2d93de1db025c138e017dcf90ec54d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/checkout-frame/utils/find-experiment.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 30
        },
        end: {
          line: 10,
          column: 15
        }
      },
      "1": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 10,
          column: 15
        }
      },
      "2": {
        start: {
          line: 8,
          column: 33
        },
        end: {
          line: 8,
          column: 56
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 30
          },
          end: {
            line: 4,
            column: 31
          }
        },
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 10,
            column: 15
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 19
          },
          end: {
            line: 8,
            column: 20
          }
        },
        loc: {
          start: {
            line: 8,
            column: 33
          },
          end: {
            line: 8,
            column: 56
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 32
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 6,
            column: 30
          },
          end: {
            line: 6,
            column: 32
          }
        }],
        line: 6
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6ee4f2d56b2d93de1db025c138e017dcf90ec54d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_10ftcu4pd6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_10ftcu4pd6();
cov_10ftcu4pd6().s[0]++;
export var findExperiment = function findExperiment(experimentName) {
  var _experiments$find;
  var experiments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_10ftcu4pd6().b[0][0]++, []);
  cov_10ftcu4pd6().f[0]++;
  cov_10ftcu4pd6().s[1]++;
  return (_experiments$find = experiments.find(function (_ref) {
    var name = _ref.name;
    cov_10ftcu4pd6().f[1]++;
    cov_10ftcu4pd6().s[2]++;
    return name === experimentName;
  })) === null || _experiments$find === void 0 ? void 0 : _experiments$find.value;
};